import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Diamond from '../components/Diamond';
import { salesTreeRegistry } from '../config/salesTreeRegistry';

const SalesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-page" data-testid="sales-page">
      <Header />

      <main className="dashboard-main">
        <div className="dashboard-container">
          <div className="dashboard-section-header">
            <span className="dashboard-label">SALES DECISION TREES</span>
            <h2 className="dashboard-heading">Sales</h2>
            <p className="dashboard-subheading">Decision trees built for specific client engagements. Click into any tree to walk through it.</p>
          </div>

          <div className="dashboard-grid">
            {salesTreeRegistry.map((tree) => (
              <div key={tree.id} className="dashboard-card" data-testid={`sales-card-${tree.id}`}>
                <div className="dashboard-card-header">
                  <span className="dashboard-card-category">{tree.category}</span>
                  <span className="dashboard-card-gates">{tree.gates} GATES</span>
                </div>

                <h3 className="dashboard-card-title">{tree.title}</h3>
                <p className="dashboard-card-description">{tree.description}</p>

                <div className="dashboard-card-actions">
                  <button
                    onClick={() => navigate(tree.route)}
                    className="dashboard-btn dashboard-btn-primary"
                    data-testid={`walkthrough-sales-${tree.id}`}
                  >
                    <Diamond color="#FFFFFF" size="xs" />
                    Walk Through
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default SalesPage;
